
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { EVENT_TYPES } from "@/lib/constants";

interface EventTypesListProps {
  eventTypes?: string;
  maxVisible?: number;
  variant?: "compact" | "pills";
}

export const EventTypesList = ({ 
  eventTypes, 
  maxVisible = 3,
  variant = "pills" 
}: EventTypesListProps) => {
  const [showAll, setShowAll] = useState(false);
  
  if (!eventTypes) return null;

  // Extract and standardize event types
  const types = eventTypes.split(',')
    .map(type => type.trim())
    .filter(type => EVENT_TYPES.includes(type as any)); // Only keep valid event types

  if (types.length === 0) return null;

  const visibleTypes = showAll ? types : types.slice(0, maxVisible);
  const hasMore = types.length > maxVisible;

  if (variant === "compact") {
    return (
      <div className="text-sm text-muted-foreground">
        {types.join(", ")}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {visibleTypes.map((type) => (
          <span
            key={type}
            className="px-2 py-1 bg-accent text-xs rounded-full text-primary"
          >
            {type}
          </span>
        ))}
        {!showAll && hasMore && (
          <Button
            variant="ghost"
            size="sm"
            className="h-6 px-2 text-xs"
            onClick={() => setShowAll(true)}
          >
            +{types.length - maxVisible} more
          </Button>
        )}
      </div>
    </div>
  );
};
